<template>
  <div class="fill-height">
    <main-mobile-view v-if="mobile" />
    <main-web-view v-else />
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';
import MainWebView from '@/views/MainWebView';
import MainMobileView from '@/views/MainMobileView';

export default {
  name: 'MainView',
  components: { MainWebView, MainMobileView },
  computed: {
    mobile: sync('tools/mobile'),
  },
  created() {
    this.mobile = window.innerWidth <= 1000;
  },
};
</script>
